// App.js
import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom'; // ✅ Switched to HashRouter
import { AuthProvider } from './context/AuthContext';

import Home from './pages/Home';
import UploadDashboard from './pages/UploadDashboard';
import Upload from './pages/Upload';
import Search from './pages/Search';
import Subscribe from './pages/Subscribe';
import Login from './pages/Login';
import Register from './pages/Register';
import RequestPasswordReset from './pages/RequestPasswordReset';
import ResetPassword from './pages/ResetPassword';
import NotFound from './pages/NotFound';

import AdminDashboard from './components/AdminDashboard';
import GadgetList from './components/GadgetList';
import UserManagement from './components/UserManagement';
import SearchLogs from './components/SearchLogs';
import SubscriptionManager from './components/SubscriptionManager';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />

          <main>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/upload" element={<UploadDashboard />} />
              <Route path="/upload/:deviceType" element={<Upload />} />
              <Route path="/search" element={<Search />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/request-password-reset" element={<RequestPasswordReset />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />

              {/* Admin-only Protected Routes */}
              <Route
                path="/nomas"
                element={
                  <ProtectedRoute adminOnly={true}>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/gadgets"
                element={
                  <ProtectedRoute adminOnly={true}>
                    <GadgetList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users"
                element={
                  <ProtectedRoute adminOnly={true}>
                    <UserManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/search-logs"
                element={
                  <ProtectedRoute adminOnly={true}>
                    <SearchLogs />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/subscriptions"
                element={
                  <ProtectedRoute adminOnly={true}>
                    <SubscriptionManager />
                  </ProtectedRoute>
                }
              />

              {/* Fallback Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
